// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M10.1073 13.8927L13.8884 21.48L20.52 3.47998L2.52002 10.1116L10.1073 13.8927ZM10.1073 13.8927L12.5821 11.4179","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"send-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2.52002 10.1116L20.52 3.47998L13.8884 21.48L10.1073 13.8927L2.52002 10.1116Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.1073 13.8927L13.8884 21.48L20.52 3.47998L2.52002 10.1116L10.1073 13.8927ZM10.1073 13.8927L12.5821 11.4179","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Send1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'send-1',
    ref,
    icon: element,
  },
));

Send1Icon.displayName = 'Send1Icon';

export default Send1Icon;
